module.exports = __webpack_public_path__ + "img/red-pita-01.a94c890e.png";